import React, {useCallback, useEffect, useState} from 'react';
import {BoxTitle} from "../../../components/admin/BoxTitle";
import {NavLink, useParams} from "react-router-dom";
import {ApiQueryParam, ApiService} from "../../../service/ApiService";
import {race} from "../../../models/race";
import {participant} from "../../../models/participant";
import {ParticipantList} from "../../../components/admin/participant/ParticipantList";
import {defaultPagination} from "../../../types/PaginationType";
import {participantResultCollectionType, participantResultType} from "../../../types/Api/ParticipantResultType";
import {participantHydrator} from "../../../models/hydrator/participantHydrator";
import {scrollTo} from "../../../service/ToolsService";
import {Pagination} from "../../../components/admin/Pagination";
import {raceHydrator} from "../../../models/hydrator/raceHydrator";
import {raceResultType} from "../../../types/Api/RaceResultType";
import {RaceCard} from "../../../components/admin/race/RaceCard";

export const Participant = () => {
  const uuid: undefined | string = useParams().uuid;

  const [initialized, setInitialized] = useState(false);
  const [race, setRace] = useState(undefined as undefined | race);
  const [participants, setParticipants] = useState([] as participant[]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(15);
  const [pagination, setPagination] = useState(defaultPagination);

  const findParticpants = useCallback((): void => {
    const apiFilters: ApiQueryParam = new ApiQueryParam();

    apiFilters.addFilter({
      op: 'eq',
      field: 'race_id',
      value: uuid ?? ''
    });

    apiFilters.addSort({
      by: 'name',
      direction: 'ASC',
    });

    apiFilters.setPage(page);
    apiFilters.setCount(count);

    setLoading(true);

    const result: Promise<participantResultCollectionType> = ApiService.get('/participant', apiFilters) as Promise<participantResultCollectionType>;
    result
      .then((r: participantResultCollectionType) => {
        setInitialized(true);
        setPagination({
          page: r._page,
          pageCount: r._page_count,
          total: r._total_items,
          count: count,
        });

        setParticipants(r._embedded.participants.map((participant: participantResultType) => {
          return participantHydrator.hydrate(participant);
        }));
      })
      .catch(() => {
        alert("Une erreur c'est produite.")

        setPagination(defaultPagination);
        setParticipants([]);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [count, page, uuid]);

  const findRace = useCallback((): void => {
    const result = ApiService.get(`/race/${uuid}`) as Promise<raceResultType>;

    result
      .then((r) => {
        setRace(raceHydrator.hydrate(r));
      })
      .catch(() => {
        alert("Une erreur c'est produite.")
      });
  }, [uuid]);

  useEffect(() => {
    findParticpants();
    findRace();
  }, [findParticpants, findRace]);

  return (
    <>
      <BoxTitle title="Gestion des participants"/>
      {race && (
        <RaceCard race={race} />
      )}
      <ParticipantList participants={participants} loading={loading} refresh={findParticpants}/>
      {initialized && (
        <Pagination pagination={pagination}
                    paginate={(p: number) => {
                      if (!loading) {
                        setPage(p);
                      }
                    }}
                    count={(c: number) => {
                      if (!loading) {
                        setPage(1);
                        setCount(c);
                      }
                    }}
        />
      )}
      <div className="mt-3 d-flex justify-content-between">
        {race && (
          <>
            <NavLink to={`/admin/season/show/${race?.season?.seasonId}`} onClick={scrollTo} className="btn btn-sm btn-info me-1">
              Retour à la saison
            </NavLink>

            <NavLink to={`/admin/participant/add/${race.raceId}`} onClick={scrollTo} className="btn btn-sm btn-primary me-1">
              <i className="fa-solid fa-plus me-1"/> Ajouter un participant
            </NavLink>
          </>
        )}
        {!race && (
          <NavLink to={`/admin/season`} onClick={scrollTo} className="btn btn-sm btn-info me-1">
            Retour aux saisons
          </NavLink>
        )}
      </div>
    </>
  )
}
